module.exports = __webpack_public_path__ + "17378377b368139390dee0f0b5c111c3.svg";